@if (media?.video?.length) {
<video autoplay loop [muted]="'muted'" class="video">
  @for (video of media?.video; track video) {
  <source [src]="video.url" [type]="video.contentType" />
  }
</video>
} @else { @if (media?.images?.length) { @for (image of media?.images | slice:
0:1; track image) {
<img [src]="image.url" class="image" />
} } }

<ng-template #images>
  @if (media?.images?.length) { @for (image of media?.images | slice: 0:1; track
  image) {
  <img [src]="image.url" class="image" />
  } }
</ng-template>

<div class="overlay"></div>
